import { CSSObject } from '@chakra-ui/react';

export const CardContainer: CSSObject = {
  bg: 'white',
  border: '0',
  boxShadow: '0 3px 8px rgba(0, 0, 0, .2)',
};
